import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.branches')
  .service('branchesAPI', BranchesAPI);

function BranchesAPI(): BringozApi {
  return {
    base: `/branches`,
    infiniteScroll: {
      address: `/branches/query`,
      cmd: 'POST'
    },
    actions: {
      // Filter goes in the body, so a large amount of ids will not blow up the URL length.
      query: {
        address: 'query',
        cmd: 'POST',
        updateable: true
      },
      createBranch: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      editBranch: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      updateExternalId: {
        address: '{id}/externalId',
        cmd: 'POST',
        updateable: false
      },
      getTotalBranches: {
        address: 'totals',
        cmd: 'GET',
        updateable: true
      },
      deleteBranch: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
      addShipperAccount: {
        address: '{id}',
        cmd: 'PUT',
        updateable: true
      },
      addMembers: {
        address: '{id}/members/add',
        cmd: 'POST',
        updateable: true
      },
      removeMembers: {
        address: '{id}/members/remove',
        cmd: 'POST',
        updateable: true
      },
      bulkUpdate: {
        address: 'bulk/update',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}
